/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateAnalysisRemarkCommentRequestDto } from '../models';
// @ts-ignore
import type { CreateAnalysisRemarkCommentResponseDto } from '../models';
// @ts-ignore
import type { CreateAnalysisRemarkRequestDto } from '../models';
// @ts-ignore
import type { CreateAnalysisRemarkResponseDto } from '../models';
// @ts-ignore
import type { GetAnalysisRemarkCommentsResponseDto } from '../models';
// @ts-ignore
import type { GetAnalysisRemarksResponseDto } from '../models';
// @ts-ignore
import type { SetAnalysisRemarkStateRequestDto } from '../models';
/**
 * AnalysisRemarksRestApi - axios parameter creator
 */
export const AnalysisRemarksRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create comment for an analysis remark
         * @param {number} analysisRemarkId 
         * @param {CreateAnalysisRemarkCommentRequestDto} createAnalysisRemarkCommentRequestDto Analysis remark comment content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalysisRemarkComment: async (analysisRemarkId: number, createAnalysisRemarkCommentRequestDto: CreateAnalysisRemarkCommentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisRemarkId' is not null or undefined
            assertParamExists('createAnalysisRemarkComment', 'analysisRemarkId', analysisRemarkId)
            // verify required parameter 'createAnalysisRemarkCommentRequestDto' is not null or undefined
            assertParamExists('createAnalysisRemarkComment', 'createAnalysisRemarkCommentRequestDto', createAnalysisRemarkCommentRequestDto)
            const localVarPath = `/api/v1/analysis-remarks/{analysisRemarkId}/comments`
                .replace('{analysisRemarkId}', encodeURIComponent(String(analysisRemarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAnalysisRemarkCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an analysis remark for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {CreateAnalysisRemarkRequestDto} createAnalysisRemarkRequestDto Analysis remark content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCandidateApplicationAnalysisRemark: async (processId: string, candidateApplicationId: string, createAnalysisRemarkRequestDto: CreateAnalysisRemarkRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createCandidateApplicationAnalysisRemark', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('createCandidateApplicationAnalysisRemark', 'candidateApplicationId', candidateApplicationId)
            // verify required parameter 'createAnalysisRemarkRequestDto' is not null or undefined
            assertParamExists('createCandidateApplicationAnalysisRemark', 'createAnalysisRemarkRequestDto', createAnalysisRemarkRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/analysis-remarks`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAnalysisRemarkRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comments for an analysis remark
         * @param {number} analysisRemarkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisRemarkComments: async (analysisRemarkId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisRemarkId' is not null or undefined
            assertParamExists('getAnalysisRemarkComments', 'analysisRemarkId', analysisRemarkId)
            const localVarPath = `/api/v1/analysis-remarks/{analysisRemarkId}/comments`
                .replace('{analysisRemarkId}', encodeURIComponent(String(analysisRemarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get analysis remarks for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationAnalysisRemarks: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateApplicationAnalysisRemarks', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getCandidateApplicationAnalysisRemarks', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/analysis-remarks`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set analysis remark state
         * @param {number} analysisRemarkId 
         * @param {SetAnalysisRemarkStateRequestDto} setAnalysisRemarkStateRequestDto Analysis remark state to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalysisRemarkState: async (analysisRemarkId: number, setAnalysisRemarkStateRequestDto: SetAnalysisRemarkStateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisRemarkId' is not null or undefined
            assertParamExists('setAnalysisRemarkState', 'analysisRemarkId', analysisRemarkId)
            // verify required parameter 'setAnalysisRemarkStateRequestDto' is not null or undefined
            assertParamExists('setAnalysisRemarkState', 'setAnalysisRemarkStateRequestDto', setAnalysisRemarkStateRequestDto)
            const localVarPath = `/api/v1/analysis-remarks/{analysisRemarkId}/state`
                .replace('{analysisRemarkId}', encodeURIComponent(String(analysisRemarkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAnalysisRemarkStateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalysisRemarksRestApi - functional programming interface
 */
export const AnalysisRemarksRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalysisRemarksRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create comment for an analysis remark
         * @param {number} analysisRemarkId 
         * @param {CreateAnalysisRemarkCommentRequestDto} createAnalysisRemarkCommentRequestDto Analysis remark comment content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnalysisRemarkComment(analysisRemarkId: number, createAnalysisRemarkCommentRequestDto: CreateAnalysisRemarkCommentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAnalysisRemarkCommentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnalysisRemarkComment(analysisRemarkId, createAnalysisRemarkCommentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisRemarksRestApi.createAnalysisRemarkComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an analysis remark for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {CreateAnalysisRemarkRequestDto} createAnalysisRemarkRequestDto Analysis remark content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCandidateApplicationAnalysisRemark(processId: string, candidateApplicationId: string, createAnalysisRemarkRequestDto: CreateAnalysisRemarkRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAnalysisRemarkResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCandidateApplicationAnalysisRemark(processId, candidateApplicationId, createAnalysisRemarkRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisRemarksRestApi.createCandidateApplicationAnalysisRemark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get comments for an analysis remark
         * @param {number} analysisRemarkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalysisRemarkComments(analysisRemarkId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnalysisRemarkCommentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalysisRemarkComments(analysisRemarkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisRemarksRestApi.getAnalysisRemarkComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get analysis remarks for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateApplicationAnalysisRemarks(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAnalysisRemarksResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateApplicationAnalysisRemarks(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisRemarksRestApi.getCandidateApplicationAnalysisRemarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set analysis remark state
         * @param {number} analysisRemarkId 
         * @param {SetAnalysisRemarkStateRequestDto} setAnalysisRemarkStateRequestDto Analysis remark state to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAnalysisRemarkState(analysisRemarkId: number, setAnalysisRemarkStateRequestDto: SetAnalysisRemarkStateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAnalysisRemarkState(analysisRemarkId, setAnalysisRemarkStateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisRemarksRestApi.setAnalysisRemarkState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalysisRemarksRestApi - factory interface
 */
export const AnalysisRemarksRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalysisRemarksRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Create comment for an analysis remark
         * @param {number} analysisRemarkId 
         * @param {CreateAnalysisRemarkCommentRequestDto} createAnalysisRemarkCommentRequestDto Analysis remark comment content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnalysisRemarkComment(analysisRemarkId: number, createAnalysisRemarkCommentRequestDto: CreateAnalysisRemarkCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateAnalysisRemarkCommentResponseDto> {
            return localVarFp.createAnalysisRemarkComment(analysisRemarkId, createAnalysisRemarkCommentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an analysis remark for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {CreateAnalysisRemarkRequestDto} createAnalysisRemarkRequestDto Analysis remark content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCandidateApplicationAnalysisRemark(processId: string, candidateApplicationId: string, createAnalysisRemarkRequestDto: CreateAnalysisRemarkRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateAnalysisRemarkResponseDto> {
            return localVarFp.createCandidateApplicationAnalysisRemark(processId, candidateApplicationId, createAnalysisRemarkRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comments for an analysis remark
         * @param {number} analysisRemarkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalysisRemarkComments(analysisRemarkId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetAnalysisRemarkCommentsResponseDto> {
            return localVarFp.getAnalysisRemarkComments(analysisRemarkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get analysis remarks for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationAnalysisRemarks(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAnalysisRemarksResponseDto> {
            return localVarFp.getCandidateApplicationAnalysisRemarks(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set analysis remark state
         * @param {number} analysisRemarkId 
         * @param {SetAnalysisRemarkStateRequestDto} setAnalysisRemarkStateRequestDto Analysis remark state to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnalysisRemarkState(analysisRemarkId: number, setAnalysisRemarkStateRequestDto: SetAnalysisRemarkStateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setAnalysisRemarkState(analysisRemarkId, setAnalysisRemarkStateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalysisRemarksRestApi - interface
 */
export interface AnalysisRemarksRestApiInterface {
    /**
     * 
     * @summary Create comment for an analysis remark
     * @param {number} analysisRemarkId 
     * @param {CreateAnalysisRemarkCommentRequestDto} createAnalysisRemarkCommentRequestDto Analysis remark comment content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAnalysisRemarkComment(analysisRemarkId: number, createAnalysisRemarkCommentRequestDto: CreateAnalysisRemarkCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateAnalysisRemarkCommentResponseDto>;

    /**
     * 
     * @summary Create an analysis remark for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {CreateAnalysisRemarkRequestDto} createAnalysisRemarkRequestDto Analysis remark content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCandidateApplicationAnalysisRemark(processId: string, candidateApplicationId: string, createAnalysisRemarkRequestDto: CreateAnalysisRemarkRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateAnalysisRemarkResponseDto>;

    /**
     * 
     * @summary Get comments for an analysis remark
     * @param {number} analysisRemarkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAnalysisRemarkComments(analysisRemarkId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetAnalysisRemarkCommentsResponseDto>;

    /**
     * 
     * @summary Get analysis remarks for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateApplicationAnalysisRemarks(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAnalysisRemarksResponseDto>;

    /**
     * 
     * @summary Set analysis remark state
     * @param {number} analysisRemarkId 
     * @param {SetAnalysisRemarkStateRequestDto} setAnalysisRemarkStateRequestDto Analysis remark state to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setAnalysisRemarkState(analysisRemarkId: number, setAnalysisRemarkStateRequestDto: SetAnalysisRemarkStateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * AnalysisRemarksRestApi - object-oriented interface
 */
export class AnalysisRemarksRestApi extends BaseAPI implements AnalysisRemarksRestApiInterface {
    /**
     * 
     * @summary Create comment for an analysis remark
     * @param {number} analysisRemarkId 
     * @param {CreateAnalysisRemarkCommentRequestDto} createAnalysisRemarkCommentRequestDto Analysis remark comment content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAnalysisRemarkComment(analysisRemarkId: number, createAnalysisRemarkCommentRequestDto: CreateAnalysisRemarkCommentRequestDto, options?: RawAxiosRequestConfig) {
        return AnalysisRemarksRestApiFp(this.configuration).createAnalysisRemarkComment(analysisRemarkId, createAnalysisRemarkCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an analysis remark for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {CreateAnalysisRemarkRequestDto} createAnalysisRemarkRequestDto Analysis remark content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCandidateApplicationAnalysisRemark(processId: string, candidateApplicationId: string, createAnalysisRemarkRequestDto: CreateAnalysisRemarkRequestDto, options?: RawAxiosRequestConfig) {
        return AnalysisRemarksRestApiFp(this.configuration).createCandidateApplicationAnalysisRemark(processId, candidateApplicationId, createAnalysisRemarkRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comments for an analysis remark
     * @param {number} analysisRemarkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAnalysisRemarkComments(analysisRemarkId: number, options?: RawAxiosRequestConfig) {
        return AnalysisRemarksRestApiFp(this.configuration).getAnalysisRemarkComments(analysisRemarkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get analysis remarks for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateApplicationAnalysisRemarks(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return AnalysisRemarksRestApiFp(this.configuration).getCandidateApplicationAnalysisRemarks(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set analysis remark state
     * @param {number} analysisRemarkId 
     * @param {SetAnalysisRemarkStateRequestDto} setAnalysisRemarkStateRequestDto Analysis remark state to set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setAnalysisRemarkState(analysisRemarkId: number, setAnalysisRemarkStateRequestDto: SetAnalysisRemarkStateRequestDto, options?: RawAxiosRequestConfig) {
        return AnalysisRemarksRestApiFp(this.configuration).setAnalysisRemarkState(analysisRemarkId, setAnalysisRemarkStateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

